/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Customer-managed browser configuration, without an MPS solution.
 */
export type CustomerManagedWhatsAppOnboardingConfigurationResponse = {
    /**
     * Durable attempt identifier required when signup completes.
     */
    attemptId: string;
    /**
     * Customer-managed billing snapshotted for this attempt.
     */
    billingMode: CustomerManagedWhatsAppOnboardingConfigurationResponse.billingMode;
    /**
     * Tenant policy revision snapshotted for this attempt.
     */
    policyRevision: number;
};
export namespace CustomerManagedWhatsAppOnboardingConfigurationResponse {
    /**
     * Customer-managed billing snapshotted for this attempt.
     */
    export enum billingMode {
        CUSTOMER_MANAGED = 'customer_managed',
    }
}

